// const API_PROXY = "https://brfenergi.se/iprog/group/2/";
const API_PROXY = "";
export const API_KEY = "3d2a031b4cmsh5cd4e7b939ada54p19f679jsn9a775627d767";


export const SPOTIFY_URL_AUTHO = API_PROXY + "https://accounts.spotify.com/api/token";
export const SPOTIFY_URL_ACCOUNT = API_PROXY+"https://accounts.spotify.com/authorize?";
export const SPOTIFY_BASE_URL = API_PROXY+"https://api.spotify.com/v1";
export const SPOTIFY_CLIENT_ID = "fd3351cde0cc4286983fbbbb3031bd07";
export const SPOTIFY_CLIENT_SECRET = "f5594f2748a248e6b11116ee317f2e7c";